let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1LwIn")).then(() => parcelRequire('alXtQ'));